<div role="document" class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title"> Messages</h5>
      <p>Panneau : {{display.label}}</p>
    </div>
    <form [formGroup]="dataAbsenceForm" #f="ngForm" (ngSubmit)="isValid(f.form) && update()" >
    <div class="modal-body ">

        <div class="form-row">
          <div class="col-2">
              <label  for="Description" >Mode d'Affichage</label>
          </div>
          <div class="col-6">
              <ng-select class="mb-2" (change)="modeChange($event)"
              dropdownPosition='bottom'
                [items]="DisplayModes" [multiple]="false"
                [bindLabel]="'label'"
                [closeOnSelect]="true" bindValue="name" formControlName="mode"
                name="selectMode">
              </ng-select>
          </div>
      </div>
        <div class="form-row">
          <div class="col-2">
              <label  for="Description" >Couleur</label>
          </div>
          <div class="col-6">
              <ng-select class="mb-2"
              dropdownPosition='bottom'
                [items]="DisplayColors" [multiple]="false"
                [bindLabel]="'label'"
                [closeOnSelect]="true" bindValue="name" formControlName="color"
                name="color">
              </ng-select>
          </div>
      </div>
      <ng-container *ngIf=" modeAffichage == 'ALTERNATE'" >
      <div formArrayName="messages" class="row">
        <div *ngFor="let item of messages.controls;let absenceIndex=index" [formGroupName]="absenceIndex"
        class="flex-row col-11 align-items-center">
        <div class="form-group row align-items-center">
          <label class="form-control-label col-auto" for="datedebut">
                Message {{absenceIndex +1}} :</label>
          <input type="text" class="col form-control" required
          [ngClass] = "{ 'forminput-invalid':f.submitted &&
          item['controls']?.msg?.errors != null}"
          formControlName="msg" />
          <ng-container *ngIf="absenceIndex > 0" >
            <span (click)="deleteDataAbsence(absenceIndex)" class="col-1">
              <i class="fa fa-trash-o text-danger" style="cursor: pointer;" aria-hidden="true" title="Supprimer"></i>
              </span>
          </ng-container>
        </div>
        <div class="col-12" *ngIf="f.submitted  && item['controls']?.msg?.errors != null" class="text-danger">champ Obligatoire</div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf=" modeAffichage != 'ALTERNATE'" >
      <div class="form-row">
        <div class="col-2">
          <label  for="datedebut">
              Message</label>
        </div>
        <div class="col-6">
          <input type="text" required
          class="col form-control"
          formControlName="messageUniique" />
      </div>
    </div>
    </ng-container>
        <ng-container *ngIf=" modeAffichage == 'ALTERNATE'" >
          <button type="button" class="btn btn-sm btn-primary" (click)="addDataAbsence()">+ Message</button>
        </ng-container>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary"  type="submit">Valider</button>
      <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">Annuler
      </button>
    </div>
  </form>
  </div>

</div>
